import { Outlet } from 'react-router-dom';

import { Footer } from '@/v2/components/Footer';

export const Main = () => {
  return (
    <div>
      <Outlet />
      <Footer />
    </div>
  );
};
